// A standalone guest's sign-back-in key (PF-19), kept on this phone. Outside the Lagos Life frame
// only (inside it, Lagos Life is who you are). Browser storage can be blocked or wiped: then the
// phone simply asks for a name again.
const KEY = 'wahala.guestKey';

export function loadGuestKey(): string | null {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function saveGuestKey(key: string | null): void {
  try {
    if (key) localStorage.setItem(KEY, key);
    else localStorage.removeItem(KEY);
  } catch {
    // storage blocked: this visit only
  }
}
